import { DownloadOutlined } from '@ant-design/icons';
import { getTenantResourceService } from '@service/tenant/tenantResource';
import { Button } from 'antd';

const TEMPLATE_FILE_PATH = 'admin/products/offerTemplate.xlsx';

export function ButtonDownloadTemplate() {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href =
      getTenantResourceService().getBaseResourceUrlWithPath(TEMPLATE_FILE_PATH);
    link.download = 'TemplateOferta.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button color='primary' variant='outlined' onClick={handleDownload}>
      <DownloadOutlined />
      Template CSV
    </Button>
  );
}
